/**
 * 微信js-sdk
 * 参考文档：https://mp.weixin.qq.com/wiki?t=resource/res_main&id=mp1421141115
 */
import wx from 'weixin-js-sdk'
import ajax from '../comm/ajax.js'
import api from './api.js'
const wxApi = {
  /**
  * [wxRegister 微信Api初始化]
  * @param  {Function} callback [ready回调函数]
  */
  wxRegister (callback) {
    ajax.ajax.get(api.api.mobile.getWXPrameter,
        {
          "url": window.location.href.split('#')[0],
          "token": "03c470d33cbd8cb8d47204a7afbishui"
        },
        res => {
            console.log(res);
            if(res.status == 200){
                var data = res.data;
                debugger
                wx.config({
                    debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来,测试完成后需要关闭。
                    appId: data.appid, // 必填，公众号的唯一标识
                    timestamp: data.timestamp, // 必填，生成签名的时间戳
                    nonceStr: data.nonceStr, // 必填，生成签名的随机串
                    signature: data.signature, // 必填，签名（加密后，下文有实现）
                    jsApiList: ['scanQRCode','onMenuShareTimeline','onMenuShareAppMessage'] // 必填，需要使用的JS接口列表，开发文档上有所有接口名称，根据需要选用就好。
                });
            }
        }
      );
    // Axios.post('http://cs-xzudh.iyuhong.com.cn/YuHong/getWxScanParameterInfo.action', { "url": window.location.href.split('#')[0]}).then((res) => {
    //     if(res.code == '200'){
    //         var data = JSON.parse(res.data);
    //         wx.config({
    //             debug: true, // 开启调试模式,调用的所有api的返回值会在客户端alert出来,测试完成后需要关闭。
    //             appId: data.appid, // 必填，公众号的唯一标识
    //             timestamp: data.timestamp, // 必填，生成签名的时间戳
    //             nonceStr: data.nonceStr, // 必填，生成签名的随机串
    //             signature: data.signature, // 必填，签名（加密后，下文有实现）
    //             jsApiList: ['scanQRCode','onMenuShareTimeline'] // 必填，需要使用的JS接口列表，开发文档上有所有接口名称，根据需要选用就好。
    //         });
    //     }
    // }).catch((error) => {
    //   console.log(error)
    // })
    // var data = {
    //     signature: "d388cb41292a7ae20a287bf012d171d7210de88a",
    //     appid: "wxbfabd3d90f97c465",
    //     jsapi_ticket: "HoagFKDcsGMVCIY2vOjf9h4i2wDphwBjZ9QwO5w1z3OPoF99yqWcHcylIDMzYu0eBvJIU0u97BuQKHFH0HwFJA",
    //     url: "http://10.100.30.102:8088/",
    //     nonceStr: "180ae99eb40f4ca7b0e5d539ae390ad0",
    //     timestamp: "1590476719"
    // }   
    // // var data = JSON.parse(data);
    // wx.config({
    //     debug: true, // 开启调试模式
    //     appId: data.appid, // 必填，公众号的唯一标识
    //     timestamp: data.timestamp, // 必填，生成签名的时间戳
    //     nonceStr: data.nonceStr, // 必填，生成签名的随机串
    //     signature: data.signature, // 必填，签名，见附录1
    //     jsApiList: ['scanQRCode','onMenuShareTimeline'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
    //   })
    wx.ready((res) => {
      // 如果需要定制ready回调方法
      if (callback) {
        callback()
      }
    })
  },
  /**
  * [ShareTimeline 微信分享到朋友圈]
  * @param {[type]} option [分享信息]
  * @param {[type]} success [成功回调]
  * @param {[type]} error   [失败回调]
  */
  ShareTimeline (option) {
    wx.onMenuShareTimeline({
      title: option.title, // 分享标题
      link: option.link, // 分享链接
      imgUrl: option.imgUrl, // 分享图标
      success () {
        // 用户成功分享后执行的回调函数
        option.success()
      },
      cancel () {
        // 用户取消分享后执行的回调函数
        option.error()
      }
    })
  },
  /**
  * [ShareAppMessage 微信分享给朋友]
  * @param {[type]} option [分享信息]
  * @param {[type]} success [成功回调]
  * @param {[type]} error   [失败回调]
  */
  ShareAppMessage (option) {
    wx.onMenuShareAppMessage({
      title: option.title, // 分享标题
      desc: option.desc, // 分享描述
      link: option.link, // 分享链接
      imgUrl: option.imgUrl, // 分享图标
      success () {
        // 用户成功分享后执行的回调函数
        option.success()
      },
      cancel () {
        // 用户取消分享后执行的回调函数
        option.error()
      }
    })
  }
}
export default wxApi


// WEBPACK FOOTER //
// ./src/comm/wxapi.js